
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Modal,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import aadhar from '../../../Img/aadhar.png'
import upload from '../../../Img/upload.svg'
import { Label } from "@mui/icons-material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';




export default function Aadhaar({ activeStep, setActiveStep }) {
  const [ok_done, setok_done] = React.useState(false);

  // console.log( activeStep," setActiveStep" )

  const dfdf = () => {
    setok_done(true);
  }

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleOtpChange = (index, event) => {
    const value = event.target.value;
    const newOtp = [...otp];

    // Ensure only numbers are entered
    const numericValue = value.replace(/\D/g, '');

    // Limit the input to a single digit
    newOtp[index] = numericValue.slice(0, 1);

    setOtp(newOtp);

    // Focus on the next input field if a digit is entered
    if (numericValue.length > 0 && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput && nextInput.focus();
    }
  };



  const [firstField, setFirstField] = useState('');
  const [secondField, setSecondField] = useState('');
  const [thirdField, setThirdField] = useState('');

  const handleInputChange = (field, value) => {
    const trimmedValue = value.slice(0, 4); // Limit to 4 characters
    switch (field) {
      case 'first':
        setFirstField(trimmedValue);
        break;
      case 'second':
        setSecondField(trimmedValue);
        break;
      case 'third':
        setThirdField(trimmedValue);
        break;
      default:
        break;
    }
  };


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const [frontimage, setfrontimage] = React.useState(null);
  const [backimage, setbackimage] = React.useState(null);

  // Handle the change in file input (on file selection)
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setfrontimage(imageUrl); // Set the image URL to the state
    }
  }

  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setbackimage(imageUrl); // Set the image URL to the state
    }
  }

  const [adharupload, setadharupload] = useState(true);
  const show_adhar_upload = () => {
    setadharupload(false);
    setOpen(false);
  }

  return (
    <div>

      {adharupload ? (

        <div className="aadhar_sec" >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <img src={aadhar} alt="img" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <h4><span>Aadhaar </span> Verification</h4>
              <div className="note"><span>Note:</span> Your profile name doesn't match your aadhaar name.So we
                have updated your aadhaar name as your profile name.
              </div>
              <label className="mt-30" >Enter your Aadhaar Number</label>
              <Box component={"div"} className="d-flex" sx={{ gap: 3 }}>
                <div className="input_box">
                  <TextField
                    type="number"
                    value={firstField}
                    onChange={(e) => handleInputChange('first', e.target.value)}
                    sx={{
                      borderRadius: "50px",
                      "& .MuiInputBase-formControl": { borderRadius: "5px", backgroundColor: "#f0f1f2" },
                      "& .MuiInputBase-input": { padding: "11px 30px", border: "0", fontSize: "20px", fontWeight: "600", textAlign: "center", letterSpacing: "0.5rem" },
                      "& fieldset": { border: "0px solid #d3d1d1 !important" },
                      "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                    }}
                  />
                </div>
                <div className="input_box">
                  <TextField
                    type="number"
                    value={secondField}
                    onChange={(e) => handleInputChange('second', e.target.value)}
                    sx={{
                      borderRadius: "50px",
                      "& .MuiInputBase-formControl": { borderRadius: "5px", backgroundColor: "#f0f1f2" },
                      "& .MuiInputBase-input": { padding: "11px 30px", border: "0", fontSize: "20px", fontWeight: "600", textAlign: "center", letterSpacing: "0.5rem" },
                      "& fieldset": { border: "0px solid #d3d1d1 !important" },
                      "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                    }}
                  />
                </div>
                <div className="input_box">
                  <TextField
                    type="number"
                    value={thirdField}
                    onChange={(e) => handleInputChange('third', e.target.value)}
                    sx={{
                      borderRadius: "50px",
                      "& .MuiInputBase-formControl": { borderRadius: "5px", backgroundColor: "#f0f1f2" },
                      "& .MuiInputBase-input": { padding: "11px 30px", border: "0", fontSize: "20px", fontWeight: "600", textAlign: "center", letterSpacing: "0.5rem" },
                      "& fieldset": { border: "0px solid #d3d1d1 !important" },
                      "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                    }}
                  />
                </div>
              </Box>

              <Link to={"#"} className='org_btn sm_txt' style={{
                borderRadius: "8px", padding: "12px 60px", margin: "20px 0 0", display: "flex", alignItems: "center", gap: "10px",
                borderRadius: "6px", textAlign: "center", justifyContent: "center"
              }} onClick={handleOpen} >
                Get OTP <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-0.00976562 7.72461C-0.00976562 7.34491 0.272388 7.03112 0.638464 6.98146L0.740234 6.97461L15.7402 6.97461C16.1544 6.97461 16.4902 7.3104 16.4902 7.72461C16.4902 8.10431 16.2081 8.4181 15.842 8.46776L15.7402 8.47461L0.740234 8.47461C0.326021 8.47461 -0.00976562 8.13882 -0.00976562 7.72461Z" fill="white" /><path d="M9.16124 2.23247C8.86772 1.94021 8.8667 1.46534 9.15896 1.17181C9.42465 0.904974 9.84126 0.879871 10.1353 1.09709L10.2196 1.16953L16.2696 7.19353C16.5373 7.46002 16.5616 7.87813 16.3426 8.1722L16.2697 8.25643L10.2197 14.2814C9.92616 14.5737 9.45129 14.5727 9.159 14.2792C8.89329 14.0124 8.86994 13.5957 9.08841 13.3025L9.1612 13.2186L14.6772 7.7247L9.16124 2.23247Z" fill="white" /></svg>
              </Link>



            </Grid>
          </Grid>
        </div>

      ) : (

        <div className="aadhar_sec" >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <h4><span>Aadhaar </span> Verification</h4>
              <div className="points">
                <p>Take pictures of both sides of your government issued ID card</p>
                <ul className="mt-20" >
                  <li>Upload a complete image of your ID document.</li>
                  <li>Ensure all details are readable in the image you upload.</li>
                  <li>Ensure the document is the original and has not expired.</li>
                  <li>Place documents against a solid-colored background.</li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <p>Upload your Front & Back Aadhaar photo</p>
              <div className="ulpoads" >
                {frontimage && (
                  <div className="upload_box" >
                    <img
                      src={frontimage}
                      alt="Selected"
                      style={{ maxWidth: '100%', height: "auto" }}
                    />
                  </div>
                )}
                {!frontimage && (
                  <div className="upload_box" >
                    <Button component="label" variant="contained" tabIndex={-1} >
                      <img src={upload} alt="img" />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange}
                        accept="image/*"
                      />
                    </Button>
                  </div>
                )}
                {backimage && (
                  <div className="upload_box" >
                    <img
                      src={backimage}
                      alt="Selected"
                      style={{ maxWidth: '100%', height: "auto" }}
                    />
                  </div>
                )}
                {!backimage && (
                  <div className="upload_box" >
                    <Button component="label" variant="contained" tabIndex={-1} >
                      <img src={upload} alt="img" />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange1}
                        accept="image/*"
                      />
                    </Button>
                  </div>
                )}
              </div>
              {frontimage && backimage &&

                <Link to={"#"} onClick={() => { setActiveStep(1) }} className='org_btn sm_txt' style={{
                  padding: "12px 60px", margin: "20px 0 0", borderRadius: "8px", display: "flex", alignItems: "center", gap: "10px",
                  borderRadius: "6px", textAlign: "center", justifyContent: "center"
                }}  >Submit
                </Link>
              }
              {!frontimage && !backimage &&
                <Link className='grey_btn' disabled style={{ display: "block", padding: "12px 10px", margin: "20px 0", borderRadius: "8px" }} >Upload </Link>
              }
            </Grid>
          </Grid>
        </div>

      )
      }
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box class="boxstyle">

            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="otp_flx">
                <span className="otp" >OTP Verification </span>
                <svg onClick={handleClose} className="cursor-pointer fill_dark_to_white" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9997 21.6673C8.89001 21.6673 6.82772 21.0417 5.0736 19.8697C3.31947 18.6976 1.9523 17.0317 1.14496 15.0826C0.33763 13.1335 0.126394 10.9888 0.53797 8.91969C0.949545 6.85056 1.96545 4.94994 3.45721 3.45818C4.94897 1.96642 6.84959 0.950522 8.91872 0.538946C10.9878 0.127371 13.1326 0.338606 15.0816 1.14594C17.0307 1.95328 18.6966 3.32045 19.8687 5.07457C21.0408 6.8287 21.6663 8.89099 21.6663 11.0007C21.6663 13.8296 20.5425 16.5427 18.5422 18.5431C16.5418 20.5435 13.8287 21.6673 10.9997 21.6673ZM10.9997 1.66732C9.15372 1.66732 7.34922 2.21471 5.81436 3.24027C4.2795 4.26583 3.08322 5.7235 2.3768 7.42894C1.67039 9.13439 1.48555 11.011 1.84568 12.8215C2.20581 14.632 3.09473 16.295 4.40002 17.6003C5.70531 18.9056 7.36835 19.7945 9.17884 20.1547C10.9893 20.5148 12.8659 20.33 14.5714 19.6235C16.2768 18.9171 17.7345 17.7208 18.7601 16.186C19.7856 14.6511 20.333 12.8466 20.333 11.0007C20.333 9.77499 20.0916 8.56132 19.6226 7.42894C19.1535 6.29657 18.466 5.26767 17.5993 4.40099C16.7327 3.53431 15.7038 2.84682 14.5714 2.37778C13.439 1.90874 12.2254 1.66732 10.9997 1.66732ZM11.8977 11.0007L14.1417 13.2473C14.2601 13.3664 14.3264 13.5277 14.326 13.6956C14.3256 13.8636 14.2584 14.0245 14.1393 14.143C14.0203 14.2615 13.859 14.3278 13.691 14.3273C13.5231 14.3269 13.3621 14.2597 13.2437 14.1407L10.9997 11.9007L8.75568 14.1407C8.69702 14.1996 8.62733 14.2465 8.55057 14.2785C8.47381 14.3105 8.3915 14.3271 8.30833 14.3273C8.22516 14.3275 8.14276 14.3114 8.06584 14.2797C7.98892 14.2481 7.91898 14.2016 7.86001 14.143C7.80105 14.0843 7.75422 14.0146 7.72219 13.9379C7.69016 13.8611 7.67356 13.7788 7.67335 13.6956C7.67291 13.5277 7.73922 13.3664 7.85768 13.2473L10.1017 11.0007L7.85701 8.75399C7.79808 8.69549 7.7513 8.62591 7.71938 8.54924C7.68745 8.47258 7.67102 8.39036 7.67102 8.30732C7.67102 8.22428 7.68745 8.14206 7.71938 8.0654C7.7513 7.98874 7.79808 7.91916 7.85701 7.86066C7.9764 7.74215 8.13779 7.67564 8.30601 7.67564C8.47423 7.67564 8.63563 7.74215 8.75501 7.86066L10.9997 10.1007L13.2443 7.86066C13.3637 7.74215 13.5251 7.67564 13.6933 7.67564C13.8616 7.67564 14.023 7.74215 14.1423 7.86066C14.2013 7.91916 14.2481 7.98874 14.28 8.0654C14.3119 8.14206 14.3283 8.22428 14.3283 8.30732C14.3283 8.39036 14.3119 8.47258 14.28 8.54924C14.2481 8.62591 14.2013 8.69549 14.1423 8.75399L11.8977 11.0007Z" fill="#1E2329" /></svg>
              </div>
            </Typography>
            <br />
            <label class="mt-30">Enter verification code</label>
            <Box sx={{ display: 'flex', gap: "10px", padding: "20px 0" }}>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <div className="input_box">
                  <TextField
                    key={index}
                    type="text"
                    inputProps={{ maxLength: 1, autoComplete: 'off', }}
                    value={otp[index]}
                    onChange={(event) => handleOtpChange(index, event)}
                    id={`otp-input-${index}`}
                    sx={{
                      borderRadius: "50px",
                      "& .MuiInputBase-formControl": { borderRadius: "5px", backgroundColor: "#f0f1f2" },
                      "& .MuiInputBase-input": { border: "0", fontSize: "clamp(16px,3vw,20px)", fontWeight: "600", textAlign: "center", letterSpacing: "0.5rem", padding: "10px" },
                      "& fieldset": { border: "0px solid #d3d1d1 !important" },
                      "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                    }}
                  />
                </div>
              ))}
            </Box>
            <Link to={"#"} className="not_receive" style={{ display: "block" }}>Didn't receive code?<span> Resend</span></Link>
            <Link onClick={show_adhar_upload} to={"#"} className='grey_btn' disabled style={{ borderRadius: "8px", display: "block", padding: "12px 10px", margin: "20px 0", color: "#787878" }} >Verify  </Link>
          </Box>
        </Modal>
      </div>
    </div>
  );
}
